import { PaytrieAPI } from '@paytrie/client'

export const OTC_STATUS_LABELS: Record<PaytrieAPI.OtcRequestStatus, string> = {
  'awaiting-fiat': 'Awaiting Fiat',
  processing: 'Processing',
  submitted: 'Submitted',
  'awaiting-crypto': 'Awaiting Crypto',
  complete: 'Complete',
  cancelled: 'Cancelled',
}

export const toOtcStatusLabel = (status: PaytrieAPI.OtcRequestStatus): string =>
  OTC_STATUS_LABELS[status]

export type OtcDirection = 'buy' | 'sell'

export type OtcTone = 'pending' | 'success' | 'failed'

const OTC_BUY_STEP_STATUSES = [
  'awaiting-fiat',
  'processing',
  'complete',
] as const satisfies readonly PaytrieAPI.OtcRequestStatus[]

const OTC_SELL_STEP_STATUSES = [
  'submitted',
  'awaiting-crypto',
  'complete',
] as const satisfies readonly PaytrieAPI.OtcRequestStatus[]

export const getOtcStepStatuses = (
  direction: OtcDirection
): readonly PaytrieAPI.OtcRequestStatus[] =>
  direction === 'buy' ? OTC_BUY_STEP_STATUSES : OTC_SELL_STEP_STATUSES

export const getOtcStepIndex = (
  status: PaytrieAPI.OtcRequestStatus,
  direction: OtcDirection
) => {
  const index = getOtcStepStatuses(direction).indexOf(status)
  return index === -1 ? null : index
}

export const getOtcTone = (status: PaytrieAPI.OtcRequestStatus): OtcTone => {
  if (status === 'complete') return 'success'
  if (status === 'cancelled') return 'failed'
  return 'pending'
}

export const getIsOtcAwaitingUser = (status: PaytrieAPI.OtcRequestStatus) =>
  status === 'awaiting-fiat'
